/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./loader.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./loader.component";
var styles_UILoaderComponent = [i0.styles];
var RenderType_UILoaderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UILoaderComponent, data: {} });
export { RenderType_UILoaderComponent as RenderType_UILoaderComponent };
export function View_UILoaderComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_UILoaderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ui-loader", [], null, null, null, View_UILoaderComponent_0, RenderType_UILoaderComponent)), i1.ɵdid(1, 49152, null, 0, i2.UILoaderComponent, [], null, null)], null, null); }
var UILoaderComponentNgFactory = i1.ɵccf("ui-loader", i2.UILoaderComponent, View_UILoaderComponent_Host_0, {}, {}, []);
export { UILoaderComponentNgFactory as UILoaderComponentNgFactory };
